import { PayloadAction } from '@reduxjs/toolkit';
import { PriceDataResponse } from './types';
import { initialState } from './index';
import {
  SingleItemResponse,
  Inserts,
} from '../../configuratorData/slice/types';
import { StemExtensions } from 'app/features/stemExtensions/slice/types';

export const reducers = {
  getPriceData(
    state,
    action: PayloadAction<SingleItemResponse[] | Inserts[] | StemExtensions[]>,
  ) {
    state.isLoading = true;
  },
  getPriceDataSuccess(state, action: PayloadAction<PriceDataResponse>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getPriceDataFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
